'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';
import { useLanguage } from '@/contexts/LanguageContext';

interface Statistic {
  id: string;
  icon: string;
  value: string;
  label: string;
  labelEn: string;
  color: string;
}

const StatisticsSection = () => {
  const { t } = useLanguage();

  const statistics: Statistic[] = [
    {
      id: 'partners',
      icon: 'BuildingStorefrontIcon',
      value: '50+',
      label: 'شريك تجاري',
      labelEn: 'Business Partners',
      color: 'text-accent'
    },
    {
      id: 'customers',
      icon: 'UsersIcon',
      value: '2000+',
      label: 'عميل راضٍ',
      labelEn: 'Satisfied Customers',
      color: 'text-success'
    },
    {
      id: 'savings',
      icon: 'ChartBarIcon',
      value: '35%',
      label: 'متوسط التوفير',
      labelEn: 'Average Savings',
      color: 'text-primary'
    },
    {
      id: 'categories',
      icon: 'Squares2X2Icon',
      value: '5',
      label: 'فئات متنوعة',
      labelEn: 'Diverse Categories',
      color: 'text-secondary'
    }
  ];

  return (
    <section className="py-8 lg:py-16 bg-secondary border-t border-accent/20">
      <div className="container mx-auto px-4 lg:px-6">
        <div className="text-center mb-6 lg:mb-12">
          <h2 className="text-2xl lg:text-4xl font-bold text-white font-amiri mb-2 lg:mb-4">
            {t('أرقامنا تتحدث عن نفسها', 'Our Numbers Speak for Themselves')}
          </h2>
          <p className="text-sm lg:text-lg text-white/70">
            {t('نفخر بثقة عملائنا وشراكاتنا القوية', 'We are proud of our customers\' trust and strong partnerships')}
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 lg:gap-6">
          {statistics.map((stat) => (
            <div
              key={stat.id}
              className="bg-white/10 backdrop-blur-sm rounded-xl shadow-lg p-4 lg:p-8 text-center transition-premium hover:shadow-xl hover:-translate-y-1 border border-accent/20"
            >
              <div className="flex justify-center mb-2 lg:mb-4">
                <div className="w-10 h-10 lg:w-16 lg:h-16 rounded-full bg-accent/20 flex items-center justify-center">
                  <Icon name={stat.icon as any} size={20} className={`lg:hidden text-accent`} />
                  <Icon name={stat.icon as any} size={32} className={`hidden lg:block text-accent`} />
                </div>
              </div>
              <h3 className={`text-2xl lg:text-4xl font-bold text-accent mb-1 lg:mb-2 data-text`}>
                {stat.value}
              </h3>
              <p className="text-xs lg:text-sm text-white/70 font-medium">
                {t(stat.label, stat.labelEn)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatisticsSection;